<template>
  <div class="exhi_live">
    <div class="title">
      <h3>{{$t('navbar.live')}}</h3>
      <button @click="addLive">{{$t('homepage.addlive')}}</button>
    </div>
    <el-row>
      <el-col :span="8">
       <!--        状态:-->
        {{ $t('common.status') }}:
        <el-select v-model="auditFlag" :placeholder="$t('common.select')" @change="getList()">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <div class="state">
      <p><span>*</span>{{ $t('common.sort') }}</p>
      <p>
        <span>{{ $t('common.statusall') }}  {{ auditInfo.entire }}</span>
        <span>{{ $tc('common.auditstatus2',0) }} {{ auditInfo.underReview }}</span>
        <span>{{ $tc('common.auditstatus2',1) }} {{ auditInfo.audited }}</span>
        <span>{{ $tc('common.auditstatus2',2) }} {{ auditInfo.auditNotPassed }}</span>
      </p>
    </div>

    <div class="box" v-if="tableData.length > 0">
      <table>
        <thead>
          <tr>
            <th style="width: 50px">{{ $t('common.Number') }}</th>
            <th>{{ $t('live.Livecover') }}</th>
            <th style="width: 350px">{{ $t('live.liveName') }}</th>
            <th style="width: 350px">{{ $t('live.liveType') }}</th>
            <th>{{ $t('common.startdate') }}</th>
            <th>{{ $t('common.status') }}</th>
            <th>{{ $t('common.operate') }}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in tableData" :key="index">
            <td>
              <input
                type="text"
                class="inut"
                v-model="item.sort"
                @change="Sort(item)"
              />
            </td>
            <td><img :src="baseUrl + item.coverPhoto?baseUrl + item.coverPhoto:''" :onerror='defaultImg' alt="显示错误" /></td>
            <td>{{ item.liveCn }}</td>
            <!--名称-->
            <td>{{ item.videoType }}</td>
            <!--类型-->
            <td>{{ item.startDate }}</td>
            <!--开始时间-->
            <td>{{ item.auditFlag }}</td>
            <!--状态-->

            <td>
              <div style="cursor: pointer">
                <span @click="rowEdit(item, index)"
                  ><i class="el-icon-edit-outline">{{ $t('common.edit') }}</i></span
                >
                <span @click="delRow(item)"
                  ><i class="el-icon-delete">{{ $t('common.delete') }}</i></span
                >
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="item">
        <!--分页 -->
        <div class="pagination">
          <!-- <span>共{{ totalNum }}条数据</span> -->
            <span>{{ $t('common.pagination',{ totalNum: totalNum }) }}</span>
          <el-pagination
            class="explore_right_pages"
            layout="prev, pager, next"
            :current-page="currentPage4"
            @current-change="handleCurrentChange"
            :page-size="6"
            :total="totalNum"
          >
          </el-pagination>
        </div>
      </div>
      <div style="color:red;font-size:23px;margin-left: 40px">
        <!-- 展商直播发布预告经组委会审核通过后，将在展会官方网站进行发布，将有利于扩大直播影响范围。 -->
        {{ $t('homepage.live_suggest') }}
      </div>
    </div>

    <div class="box1" v-else>
       <div class="imgg">
		    <img src="../../../static/nodata.png" alt="" />
           <div> {{$t('homepage.nonlive')}}</div>
	   </div>
    </div>
  </div>
</template>

<script>
import { liveList, editSort, del, statistical } from "../../../../api/live.js";
import { forMat } from "../../../../utils/common.js";
export default {
  data() {
    return {
      baseUrl: forMat(),
      options: [
        {
          value: "",
          label:this.$t('common.statusall') ,
        },
        {
          value: 0,
          label: this.$t('dialog.undeed'),
        },
        {
          value: -1,
          label: this.$t('dialog.nounder'),
        },
        {
          value: 2,
          label: this.$t('dialog.undering'),
        },
      ],
      tableData: [],
      value: "",
      currentPage4: 1,
      //审核信息
      auditInfo: {},
      //审核状态
      auditFlag: "",
      //当前的页码
      pageNum: "1",

      totalNum:10  //总条数


    };
  },

  methods: {
    // 删除
    delRow(item) {
      this.$confirm(this.$t('dialog.confirmDelete'), this.$t('dialog.attention'), {
        confirmButtonText: this.$t('dialog.sure'),
        cancelButtonText: this.$t('dialog.cancel'),
        customClass: "myClass",
      })
        .then(() => {
          this.delLivee(item);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    addLive() {
      this.$router.push("/backIndex/addexhiLive");
    },

    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList(this.pageNum);
      // console.log(this.pageNum);
    },
    //点击编辑跳转，并且携带路由参数
    rowEdit(item) {
      item.title = '直播编辑';
      // this.$router.push({ name: "addExhiLive", query: { data: JSON.stringify(item) } });
      this.$router.push({ name: "addExhiLive", query: { data: item.id } });
    },
    //获取列表数据
    async getList(pageNum) {
      let list = {};
      list.auditFlag = String(this.auditFlag);
      list.pageNo = pageNum; //页码
      list.pageSize = "6"; //每页的数量
      let { data } = await liveList(list);
      // console.log("******",data);
      if (!data.data.hasOwnProperty("list")) {
        this.tableData = [];
   
        return false;
      }
      data.data.list.forEach((item) => {
        item.auditFlag == 0 ? (item.auditFlag = "审核通过") : "";
        item.auditFlag == -1 ? (item.auditFlag = "未通过") : "";
        item.auditFlag == 2 ? (item.auditFlag = "审核中") : "";

        item.videoType == 1 ? (item.videoType = "上传视频") : "";
        item.videoType == 2 ? (item.videoType = "直播外链") : "";
        item.videoType == 3 ? (item.videoType = "直播入口二维码") : "";
      });
       this.totalNum = data.data.count;
      this.tableData = data.data.list;
          //  console.log("-----",this.tableData);
    },
    //修改排序
    async Sort(item) {
      let liveMsg = {};
      liveMsg.id = item.id;
      liveMsg.sort = item.sort;
      let data = await editSort(liveMsg);
      this.getList(this.pageNum);
    },
    //删除直播
    async delLivee(item) {
      let { data } = await del({ id: item.id });
      if (data.code == 200) {
        this.getList(this.pageNum);
        this.$message({ message:this.$t('dialog.deletSucce'), type: "success" });
        return false;
      }
      
    },
    //状态审核统计
    async state() {
      let { data } = await statistical();
      this.auditInfo = data.data;
    },
  },
  computed:{
      defaultImg(){
         return ('this.src="' + require("../../../static/exLiveList.png") + '"');
      }
  },

  created() {
    this.getList("1");
    this.state();
  },

};
</script>
<style lang="scss" scoped>
.exhi_live {
  box-sizing: border-box;
  background: white;

  padding: 18px 26px 0 0;
  .title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 34px;
    border-bottom: 1px solid #e9e9e9;
    padding-bottom: 17px;
    padding-left: 26px;
    h3 {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
    button {
      width: 77px;
      height: 32px;
      background: #006fb8;
      color: white;
      border-radius: 2px;
      border: none;
    }
  }
  .el-row {
    padding-left: 26px;
  }
  .state {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    font-size: 12px;
    p:first-child {
      color: red;
    }
    span {
      margin-left: 26px;
    }
  }
  .box {
    position: relative;
    min-height: calc(100vh - 305px);

    table {
      margin: 15px 26px 0px 26px;
      border-collapse: collapse;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      border-radius: 3px 3px 0px 0px;
      width: 98%;
      overflow: hidden;
      thead {
        //width: 100%;
        background: #006fb8;
        border-radius: 4px 4px 0px 0px;
        tr {
          height: 36px;
          color: rgba(255, 255, 255, 0.85);
          width: 100%;
          th {
            box-sizing: border-box;
            height: 36px;
            width: 200px;
            color: white;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.85);
            border: none !important;
          }
        }
      }
      tbody {
        tr {
          height: 106px;
          border-bottom: 1px solid #e8e8e8;
          td {
            text-align: center;
            height: 106px;
            img {
              width: 104px;
              height: 78px;
              margin: 10px 0px;
            }
            span {
              color: #006fb8;
              margin: 0px 5px;
            }
            .inut {
              display: block;
              width: 35px;
              height: 24px;
              border: 1px solid #e0e0e0;
              line-height: 24px;
              color: #666666;
              margin-left: 25px;
              text-align: center;
            }
          }
          &:nth-child(even) {
            background-color: #f6f6f7;
          }
        }
      }

      .leaseCount {
        width: 100px;
        div {
          margin: 0 auto;
          text-align: center;
          width: 92px;
        }
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      // position: absolute;
      margin-top: 20px;
      span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-top: 6px;
        color: #666666;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
    margin-left: 10px;
  }
  .btn-next {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
  }
  .el-pager .number {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    margin-right: 5px;
    margin-right: 5px;
    color: #999999;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    border: none;
    cursor: pointer;
    background: #006fb8;
    color: #fff;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 28px;
    color: #999;
  }
}
</style>
<style lang="scss">
.myClass {
  border: none;
  .el-message-box__header {
    background: #006fb8;
    color: white !important;
  }
  .el-button--primary {
    background: #006fb8;
  }
}
.el-message-box__title {
  color: white !important;
}

.box1 {
 
  width: 100%;
  height: 70vh;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 400px;
    height: 300px;
  
  }
}
</style>
